import { StatusType, SynchronizedType } from '../../../../order.types';
import {
  ForceSyncOrderStatusRule,
  IForceSyncOrderStatusRule,
} from '../force-sync-order-status-rule.interface';

export class ApprovedForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync({ orderStatusSync, triggerIntegrationConfig }: ForceSyncOrderStatusRule): boolean {
    const allowedStatusToTrigger = [StatusType.APPROVED, StatusType.ON_APPROVAL];

    const availableForSync =
      orderStatusSync &&
      triggerIntegrationConfig &&
      allowedStatusToTrigger.includes(triggerIntegrationConfig) &&
      [
        SynchronizedType.ERROR,
        SynchronizedType.NOT_SYNCHRONIZED,
        SynchronizedType.SUCCESS_WITH_PAYMENT_ERROR,
      ].includes(orderStatusSync);

    if (!availableForSync || !triggerIntegrationConfig) {
      return false;
    }

    return true;
  }
}
